require('../bootstrap');

import env from '../config/env';
import router from  '../router/index'

const baseURL = env.baseURL;
const normalURL = env.normalURL;
const frontUrl = env.frontUrl;

const store = {
    state: {
        user: {
            name: '',
            picture: '',
            job: '',
            email: '',
            id: 0
        },
        authenticated: false,
        token: '',
        api: baseURL,
        url: normalURL,
        frontUrl: frontUrl,
        breadcrumbs: [{ name: "Home", route: "/" }],
        showLoader: false
    },
    getters: {
        token: state => {
            return state.token;
        },
        authenticated: state => {
            if (state.token == null || state.token == 'null') {
                return false;
            }

            return state.authenticated;
        },
        logo: state => {
            return state.logo;
        },
        user: state => {
            return state.user;
        },
        api: state => {
            return state.api;
        },
        breadcrumbs: state => {
            return state.breadcrumbs;
        },
        showLoader: state => {
            return state.showLoader
        }
    },
    mutations: {
        auth(state, token) {
            if (token != null && token != undefined) {
                state.authenticated = true;
                state.token = token;

                localStorage.clear();
                localStorage.setItem('token', token);

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.commit('profileUpdate');
            }
        },
        profileUpdate(state) {
            axios.post(state.api + 'me', {
                token: state.token
            })
                .then(response => {
                    state.user = response.data;
                    
                    localStorage.setItem('completed_first_part_onboarding', response.data.completed_first_part_onboarding ? '1' : '0');
                })
                .catch(error => {
                    localStorage.clear();

                    router.push('/login');
                });
        },
        updateBreadCrumbs(state, newRoute) {
            if (state.breadcrumbs.length > 1) {
                state.breadcrumbs.pop();
            }
            state.breadcrumbs.push(newRoute)
            // state.breadcrumbs = newRoute;
        },
        changeLoader(state, boolean){
            state.showLoader = boolean
        }
    },
    actions: {
        changeLoader(context, boolean){
            context.commit('changeLoader', boolean);
        },
        initialize(context) {
            const token = localStorage.getItem('token');

            context.commit('auth', token);
        }
    }
};

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js